import { Component, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import {  MessageService, SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { GlobalService } from 'src/app/_services/global.service';

import { Router } from '@angular/router';

import { ApiService } from 'src/app/_services/api.service';



import * as moment from 'moment';
import { Dropdown } from 'primeng/dropdown';
import { environment } from 'src/environments/environment';
import { GridtooltipComponent } from '../../general/grid-addons/gridtooltip/gridtooltip.component';


import { GridComponent, AggregateService, ReorderService , GroupService, GroupSettingsModel,PdfExportService, ToolbarService,PageService, ToolbarItems, ColumnModel, SortService, FilterService, PdfExportProperties, ColumnChooserService, GroupEventArgs, ResizeService, SortEventArgs, PdfQueryCellInfoEventArgs, ExcelExportService, TextWrapSettingsModel, WrapMode  } from '@syncfusion/ej2-angular-grids';
import {
  PdfStandardFont,
  PdfFontFamily,
  PdfFontStyle,
  PdfPageOrientation,
} from '@syncfusion/ej2-pdf-export';

import  itlocale  from 'src/app/itgridlocale.json';
import { L10n } from '@syncfusion/ej2-base';
//L10n.load(itlocale);



@Component({
  selector: 'app-surveys-results',
  templateUrl: './surveys-results.component.html',
  styleUrls: ['./surveys-results.component.css'],
  providers: [ MessageService,ResizeService,PageService,ColumnChooserService,AggregateService,ReorderService, FilterService, SortService, GroupService,ExcelExportService,PdfExportService, ToolbarService],
 
})

export class SurveysResultsComponent implements OnInit {
  @ViewChild('grid') public grid: GridComponent | undefined;

  exportProperties?: PdfExportProperties;
  public locale: any = "it";

  fileName:string="Export pdf.pdf";
  public wrapSettings?: TextWrapSettingsModel;
  allowExcelExport=true;
  initial:boolean=true;
  showgrid:boolean=false;
  showCharts:boolean=false;
  pptxrsa:any=null;
  lavillacompanylist:any[] = [];  
  lavillaarealist:any[] = [];  
  pptxlavillacompany:any=null;
  pptxlavillaarea:any=null;
  pptxsurvey:any=null;
  companylist: SelectItem[] = [];  
  rsalist: SelectItem[] = [];  
  echartsOptions: object = {};
  echartsOptionsCompany: object = {};
  echartsOptionsArea: object = {};
  scoreTotal=0;
  columns: any[] = [];
  autoFitcolumns: any[] = [];
  public aggregateColumn: Object[];

  surveylist: any[] = [];  
  surveycompanylist: any[] = [];  
  schema: SelectItem[] = [];  
  public rowGroupPanelShow: 'always' | 'onlyWhenGrouping' | 'never' = 'always';
  surveysresults: any[] = [];
  
  
  suppressAggFuncInHeader=true;
  schemaName='';
  surveyName='';
  
  
  
  company:any=null;

  filtro={
    survey:null,
    onlymandatory:null,
    schema:null,
    ischart:false,
    details:true,
   
  };


  public groupOptions?: GroupSettingsModel;
  public toolbarOptions?: ToolbarItems[];
  public filterSettings: Object | undefined;
  public filter: any;

  public initialSort: object= {columns: [] };
  
  
  
  defaultSortModel = [
    { colId: 'name', sort: 'asc', sortIndex: 0 },
  ];
  legend:any=[];
  itemslist:any=[];
  series:any=[];
  chartsList:any[]=[];
  legendD:any=[];
  legend_S:any=[];
  itemslist_S:any=[];
  series_S:any=[];
  legend_A:any=[];
  noArea=false;
  itemslist_A:any=[];
  series_A:any=[];

  constructor(
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService,
    public globalService: GlobalService,
    private apiService: ApiService,
  ) {


  }

  

  ngOnInit(): void {
   
    this.toolbarOptions = ['ExcelExport','Search','ColumnChooser'];
    this.filterSettings = { type: 'Excel', enableInfiniteScrolling: true };
    this.wrapSettings = { wrapMode: 'Content' };
    const params: any = {PageSize : 10000};
    this.apiService.get('surveys/listall',params).subscribe(data => {
      data.Result.forEach((q)=>{
        if(q.company){
          if(this.companylist.filter((x)=>x.value==q.company).length==0){
            this.companylist.push({
              label:q.company.replace('_',' '),
              value:q.company
            });
          }
        }
        this.surveylist.push({
          label:q.name,value:q.id,company:q.company
        });
      });
      
    });
    this.apiService.get('surveys-startup-models/listall',params).subscribe(data => {
      data.Result.forEach((q)=>{
        this.schema.push({
          label:q.name,value:q.id
        });
      });
    });
  
   // this.load();
   
  }

  pdfQueryCellInfo(args: any): void {
    (args as any).value =(args as any).value.replace(/[^\x20-\x7E]/g, '');
  }

  dataBound(args:any) { 
   
   // this.grid.autoFitColumns(); // autofit all the columns 
    this.grid.autoFitColumns(this.autoFitcolumns); // autoFit particular column 

    this.grid.width = '90vw';//(this.grid.getContentTable() as any).offsetWidth;   
    if (this.initial === true) {
            (this.grid as GridComponent).groupModule.collapseAll();
            this.initial = false;
        }
          
  } 
  
  toolbarClick(args: any): void {
  
    let d=new Date();
    let dformat = [d.getMonth()+1,
      d.getDate(),
      d.getFullYear()].join('_')+'_'+
     [d.getHours(),
      d.getMinutes(),
      d.getSeconds()].join('_');
    let title='Survey results ';
    if ( args.item.prefixIcon=='e-excelexport') { // 'Grid_pdfexport' -> Grid component id + _ + toolbar item name
      (this.grid as GridComponent).excelExport();
      return;
    }
    this.exportProperties= {
      fileName:title+' '+dformat+'.pdf',
      theme: {
        record: {font:  new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Regular)}
      },
      allowHorizontalOverflow:false,
      pageOrientation: 'Landscape',
      header: {
        fromTop: 0,
        height: 100,
        contents: [
          {
            type: 'Text',
            value:title,
            font:  new PdfStandardFont(PdfFontFamily.Helvetica, 14),
            position: { x:150, y: 30 },
            style: { textBrushColor: '#000000', fontSize: 14 },
          },
          {
            type: 'Line',
            style: { penColor: '#000080', penSize: 1, dashStyle: 'Solid' },
            points: { x1: 0, y1: 70, x2: 1005, y2: 70 },
          },
        ],
      },
      footer: {
        fromBottom: 0,
        height: 25,
        contents: [
          {
            type: 'PageNumber',
            pageNumberType: 'Arabic',
            
            format: 'Pag. {$current} di {$total}', //optional
            position: { x: 0, y: 5 },
            style: {
              fontSize: 12,
              hAlign: 'Center',
            },
          },
         
        ],
      },
    };
    if (args.item.prefixIcon=== 'e-pdfexport') { // 'Grid_pdfexport' -> Grid component id + _ + toolbar item name
      (this.grid as GridComponent).pdfExport(this.exportProperties);
    }
  }
  
  pptx_per_domanda(what){
    let params;
    if(what==''){
        params={
        survey:this.pptxsurvey,
        rsa:this.pptxrsa
      };
    }  
    if(what=='company'){
      params={
      survey:this.pptxsurvey,
      company:this.pptxlavillacompany
      };
    }
    if(what=='area'){
      params={
      survey:this.pptxsurvey,
      area:this.pptxlavillaarea
      };
    }
 
  
    this.apiService.get('surveys/surveys_pptx_per_domanda',params).subscribe(data => {
      window.open(
        environment.QUESTIONARI_URL+data.Result['filepptx'],
        '_blank' // <- This is what makes it open in a new window.
      );
    });

  }
   
  percFormatter(params) {
    console.log(params.value);
   if(params.value)
    return params.value.toString()+' %';
  else 
   return '';
  }

  load(what){
    this.initial=true;
    this.showgrid=false;
    this.load2(what);
   
  }
  
  load2(what){
     
    const params: any = {showresults : true};
    params.tipo=what;
  
   
    if(this.filtro.ischart){
      this.filtro.details=false;
    }
    params.details=this.filtro.details;
    params.onlymandatory=this.filtro.onlymandatory;
    
    if(what=='schema'){
      params.schema=this.filtro.schema;
    }else {
      params.survey=this.filtro.survey;
    }
    
    this.columns=[];
   
    this.apiService.get('surveys/listallresults',params).subscribe(data => {
        
     

    //  if(this.filtro.details){
        this.columns= [];
        if(data.Result.scoretot){
          this.scoreTotal=data.Result.scoretot;
        }
     
        this.autoFitcolumns= [];

        data.Result.columns.forEach((r:any,ind:number)=>{
         
          if(r.field!='societa' && r.field!='area' )
          this.columns.push(r);
          if(ind<4){
            this.autoFitcolumns.push(r.field);
           
          }
        });
  
        this.columns.forEach((r:any,ind)=>{

          if(r.field=='date_time_survey'){
           
            r.valueFormatter= (data) =>{
               return  data.value;
            }
            
          }
    
          if(r.field=='score_perc'){
            r.valueFormatter= this.percFormatter.bind(this);
            r.textAlign='Right';
          }
          if(r.field=='part_perc'){
            r.valueFormatter= this.percFormatter.bind(this);
            r.textAlign='Right';
          }
          if((r.choices)&&(r.choices.length>1)){
            this.columns[ind].headerName+=' '+r.choices[0]+'-'+r.choices[r.choices.length-1];
            r.textAlign='Right';
          } else {
            if(r.typeSurvey=='rating'){
              this.columns[ind].headerName+=' 0-'+r.max;
              r.textAlign='Right';
            }
          }
          if(r.typeSurvey=='boolean'){
            this.columns[ind].headerName+=' 0-1';
            r.textAlign='Right';
          }
      
          
        });
      
      this.surveysresults=data.Result.data;
      if(this.filtro.details){

        this.columns.forEach((x:any)=>{
          if(x.typeSurvey=='rsalist'){
            this.groupOptions = { 
              columns: [x.field] };
          }
          if(x.typeSurvey=='text'){
           x.clipMode='EllipsisWithTooltip';
          }

          
        });
      }
      this.aggregateColumn =  [{
            columns: [
                {
                  type: ['Max','Average'],
                  field: 'score',
                  format:'N0',
                  footerTemplate: 'Max: ${Max}, Avg:${Average}',
                  groupFooterTemplate: 'Max: ${Max}, Avg:${Average}',
                }
            ]
            }];

      this.showgrid=true;
    
    
   
   /*
      if(!this.filtro.details){
       
        this.itemslist=[];
        this.legend=[];
        var itemname='';
        this.series=[];
        this.columns.forEach((r)=>{
          if(r['typeSurvey']=='rsalist'){
            itemname=r['field'];
          } else{
            if(r['field'] && r['field']!='score' && r['field']!='area' && r['field']!='societa'){
              let nomecol='';
              let titlecol='';
              nomecol=r['headerName'];   
              titlecol=r['field'];  
              this.legend.push(nomecol);
              this.series.push(
                {
                  name: titlecol,
                  nomecol:nomecol,
                  type: "bar",
                  data: []
                }
              );
            }
          }
        });
      
        data.Result.data.forEach((r)=>{
          if(!this.itemslist.includes(r[itemname])){
            this.itemslist.push(r[itemname]);
          }
          Object.keys(r).forEach((key)=> {
            if((key!='score')&&(key!=itemname)){
              this.series.forEach((s)=>{
                if(s['name']==key){
                  s['data'].push(r[key]);
                }
              });
            }
          });
        });
        
        this.echartsOptions = {
          tooltip: {
              trigger: "item",
              axisPointer: {
              type: "shadow"
              },
              formatter: (params) => {
                return this.legend[params.componentIndex]+': '+params.data;
              },
          },
          grid: {
              left: "3%",
              right: "4%",
              bottom: "8%",
              top: "3%",
              containLabel: true
          },
          xAxis: {
               type: "value"
          },
          yAxis: {
              type: "category",
              data: this.itemslist,
              axisLabel: {
              interval: 0,
              rotate: 15
              }
          },
       
          series: this.series
        };


        this.itemslist_A=[];
        this.legend_A=[];
        this.series_A=[];

        this.columns.forEach((r)=>{
          if(r['typeSurvey']=='area'){
            itemname=r['field'];
          } else{
            if(r['field'] && r['field']!='score' && r['field']!='societa'){
              let nomecol='';
              let titlecol='';
              nomecol=r['headerName'];   
              titlecol=r['field'];  
              this.legend_A.push(nomecol);
              this.series_A.push(
                {
                  name: titlecol,
                  nomecol:nomecol,
                  type: "bar",
                  data: []
                }
              );
            }
          }
        });
        this.noArea=true;
        data.Result.data_A.forEach((r)=>{
          if(r['area']!='')
           this.noArea=false;
        });
        data.Result.data_A.forEach((r)=>{
          if(!this.itemslist_A.includes(r[itemname])){
            this.itemslist_A.push(r[itemname]);
          }
          Object.keys(r).forEach((key)=> {
            if((key!='score')&&(key!=itemname)){
              this.series_A.forEach((s)=>{
                if(s['name']==key){
                  s['data'].push(r[key]);
                }
              });
            }
          });
        });
        this.echartsOptionsArea = {
          tooltip: {
              trigger: "item",
              axisPointer: {
              type: "shadow"
              },
              formatter: (params) => {
                return this.legend_A[params.componentIndex]+': '+params.data;
              },
          },
          grid: {
              left: "3%",
              right: "4%",
              bottom: "8%",
              top: "3%",
              containLabel: true
          },
          xAxis: {
               type: "value"
          },
          yAxis: {
              type: "category",
              data: this.itemslist_A,
              axisLabel: {
              interval: 0,
              rotate: 15
              }
          },
       
          series: this.series_A
        };
        
        this.itemslist_S=[];
        this.legend_S=[];
        this.series_S=[];

        this.columns.forEach((r)=>{
          if(r['typeSurvey']=='societa'){
            itemname=r['field'];
          } else{
            if(r['field'] && r['field']!='score'){
              let nomecol='';
              let titlecol='';
              nomecol=r['headerName'];   
              titlecol=r['field'];  
              this.legend_S.push(nomecol);
              this.series_S.push(
                {
                  name: titlecol,
                  nomecol:nomecol,
                  type: "bar",
                  data: []
                }
              );
            }
          }
        });
      
        data.Result.data_S.forEach((r)=>{
          if(!this.itemslist_S.includes(r[itemname])){
            this.itemslist_S.push(r[itemname]);
          }
          Object.keys(r).forEach((key)=> {
            if((key!='score')&&(key!=itemname)){
              this.series_S.forEach((s)=>{
                if(s['name']==key){
                  s['data'].push(r[key]);
                }
              });
            }
          });
        });
        this.echartsOptionsCompany = {
          tooltip: {
              trigger: "item",
              axisPointer: {
              type: "shadow"
              },
              formatter: (params) => {
                return this.legend_S[params.componentIndex]+': '+params.data;
              },
          },
          grid: {
              left: "3%",
              right: "4%",
              bottom: "8%",
              top: "3%",
              containLabel: true
          },
          xAxis: {
               type: "value"
          },
          yAxis: {
              type: "category",
              data: this.itemslist_S,
              axisLabel: {
              interval: 0,
              rotate: 15
              }
          },
       
          series: this.series_S
        };
        

      }   
   */
      
    });
  
  }

  
changeSurvey(event, dd: Dropdown){
 this.surveyName=dd.selectedOption.label;
}

changeCompany(event, dd: Dropdown){
  this.surveycompanylist=this.surveylist.filter((c)=>c.company==this.company);
}

changeSurvey2(event, dd: Dropdown){
  console.log(dd.selectedOption.value);
  this.apiService.get('dosurvey/get',{id:dd.selectedOption.value,fromArkiweb:true}).subscribe(data => {
    for (const g of data.Result) {
  
      this.apiService.get('dosurvey/rsalistall',{rsa_id:g['rsa_list_id'],fromArkiweb:true}).subscribe(data => {
        for (const g of data.Result) { 
          this.rsalist=[];
          g['rsalist'].forEach((r:any)=>{
            this.rsalist.push({
              value:r['code'],
              label:r['description']
            });
          });
         
        }
      });
      this.apiService.get('dosurvey/areacompanylistall',{rsa_id:g['rsa_list_id']}).subscribe(data => {
        this.lavillaarealist=[];
     
        data.Result.aree.forEach((a)=>{
          this.lavillaarealist.push({
            value:a,
            label:a
          });
        });
        this.lavillacompanylist=[];
        data.Result.societa.forEach((a)=>{
          this.lavillacompanylist.push({
            value:a,
            label:a
          });
        });
  
      });
    }
  });
 }


changeSchema(event, dd: Dropdown){
  this.schemaName=dd.selectedOption.label;
 }
 
 public aggFuncs: {
    [key: string]: any;
    } = {
      'avgAggFunction': roundedAvgAggFunction
    }
    
}

function avgFunction(params: any) {
  // the average will be the sum / count
  let sum = 0;
  let count = 0;
 
  params.values.forEach((value) => {
    const groupNode =
      value !== null && value !== undefined && typeof value === 'object';

    if (groupNode) {
      // we are aggregating groups, so we take the
      // aggregated values to calculated a weighted average
      sum += value.avg * value.count;
      count += value.count;
    } else {
     
      // skip values that are not numbers (ie skip empty values)
      if (typeof value === 'number') {
        sum += value;
        count++;
      }
    }
  });
  // avoid divide by zero error
  let avg = null;
  if (count !== 0) {
    avg = sum / count;
  }
  // the result will be an object. when this cell is rendered, only the avg is shown.
  // however when this cell is part of another aggregation, the count is also needed
  // to create a weighted average for the next level.
  const result = {
    count: count,
    avg: avg,
    // the grid by default uses toString to render values for an object, so this
    // is a trick to get the default cellRenderer to display the avg value
    toString: function () {
      return `${this.avg}`;
    },
  };
  return result;
}
function roundedAvgAggFunction(params: any) {
  const result = avgFunction(params);
  if (result.avg) {
    result.avg = Math.round(result.avg * 100) / 100;
  }
  return result;
}


